import { render } from "react-dom";
import App from "./App";

// Buffer Problem fix for webpack 5.
// Ref: https://github.com/Uniswap/web3-react/issues/423
import { Buffer } from "buffer";
if (!window.Buffer) window.Buffer = Buffer;

const root = document.getElementById("root");
render(<App />, root);
